import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-store-3-line',
      title: 'Wholesale Distribution',
      description: 'Bulk orders for retailers, restaurants, and businesses with competitive pricing and reliable supply chain management.',
      features: ['Volume Discounts', 'Regular Supply', 'Credit Terms', 'Business Support']
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'Retail Sales',
      description: 'Individual purchases for personal consumption with personalized service and expert recommendations.',
      features: ['Personal Service', 'Gift Wrapping', 'Product Advice', 'Special Orders']
    },
    {
      icon: 'ri-truck-line',
      title: 'Delivery Services',
      description: 'Fast and reliable delivery across Ghana with secure packaging and tracking for your peace of mind.',
      features: ['Same Day Delivery', 'Secure Packaging', 'Order Tracking', 'Nationwide Coverage']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Support',
      description: 'Exceptional customer care with knowledgeable staff ready to assist with all your beverage needs.',
      features: ['Expert Advice', '24/7 Support', 'Product Training', 'After-sales Service']
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Our <span className="text-yellow-400">Services</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Comprehensive beverage solutions tailored to meet your needs, from wholesale distribution to personalized retail service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-900 rounded-2xl p-6 hover:bg-gray-800 transition-all duration-300 transform hover:-translate-y-2 border border-yellow-400/20">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-black text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-yellow-400">{service.title}</h3>
              <p className="text-gray-300 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-400">
                    <i className="ri-check-line text-yellow-400 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-2xl p-8 md:p-12 text-black">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to Experience Premium Service?
            </h3>
            <p className="text-xl mb-8 opacity-90">
              Join thousands of satisfied customers who trust Cheers for their beverage needs. 
              Contact us today to discuss your requirements.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="secondary" size="lg">
                <i className="ri-phone-line mr-2"></i>
                Get Quote
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="border-black text-black hover:bg-black hover:text-yellow-400"
                onClick={scrollToContact}
              >
                <i className="ri-mail-line mr-2"></i>
                Email Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
